import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { IconProps } from './types';

export const Icon = ({ rounded, component: Component, ...props }: ExtendedIconProps) => {
  const IconComponent = <Component {..._.omit(props, ['component', 'rounded'])} />;

  return rounded ? <IconRounded>{IconComponent}</IconRounded> : IconComponent;
};

const IconRounded = styled.div`
  background-color: ${colors.blue100};
  border-radius: 50%;
  width: 156px;
  height: 156px;
  display: flex;
  justify-content: center;
  align-items: center;

  > * {
    color: ${colors.blue600};
  }
`;

interface ExtendedIconProps extends Omit<IconProps, 'component'> {
  component: React.ForwardRefExoticComponent<AntdIconProps & React.RefAttributes<HTMLSpanElement>>;
  rounded?: boolean;
}
